import { useState, useEffect } from 'react';
import { getManualExists, replaceManual } from 'lib/communication/userInfo';

const useManual = () => {
    const [manualExists, setManualExists] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [statusMessage, setStatusMessage] = useState('');

    const checkManualExists = async () => {
        const exists = await getManualExists();
        setManualExists(exists);
        setIsLoading(false);
    };

    useEffect(() => {
        checkManualExists();
    }, []);

    const uploadManual = async (file: File | null): Promise<void> => {
        if (!file) {
            setStatusMessage('Nie wybrano pliku.');
            return;
        }
        if (file.type !== 'application/pdf') {
            setStatusMessage('Niepoprawny format pliku. Proszę wybrać plik .pdf');
            return;
        }

        const success = await replaceManual(file);
        if (success) {
            setManualExists(true);
            setStatusMessage('Poprawnie zaktualizowano instrukcję obsługi.');
        } else {
            setStatusMessage('Wystąpił błąd podczas aktualizacji instrukcji obsługi. Proszę spróbować ponownie.');
        }
    };

    return { manualExists, isLoading, statusMessage, uploadManual };
};

export default useManual;
